
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#FFE86C"}}),_c('path',{attrs:{"d":"M18.98 17.08a.247.247 0 00.02-.1.228.228 0 00-.04-.094.447.447 0 00-.119-.11l-2.589-1.631-.024-.008a.19.19 0 00-.052-.021.768.768 0 00-.132-.017.53.53 0 00-.183.018.531.531 0 00-.16.08l-.833.692v.002a.57.57 0 01-.249.116 1.346 1.346 0 01-.089.018c-.045.007-.085.01-.121.007l-.073-.01-.171-.043a1.67 1.67 0 01-.275-.1 4.2 4.2 0 01-.311-.155v-.001c-.616-.339-1.324-.933-1.943-1.586-.623-.658-1.165-1.385-1.438-1.98a3.26 3.26 0 01-.154-.38 2.117 2.117 0 01-.084-.355l-.004-.064a.575.575 0 01.056-.203.746.746 0 01.055-.104.487.487 0 01.099-.11l.728-.597.001.001a.46.46 0 00.152-.233.297.297 0 00.013-.116.245.245 0 00-.03-.099l-.003-.008-1.313-2.713a.565.565 0 00-.127-.142.133.133 0 00-.04-.022A.188.188 0 009.49 7v.002a.233.233 0 00-.089.01.33.33 0 00-.098.059L7.327 8.688l-.015.012a.524.524 0 00-.082.075.962.962 0 00-.189.36l-.008.062-.023.183-.004.028-.002.03h.001v.011h-.002c-.004.06-.004.132-.001.216.003.085.01.18.022.288.178 1.743 1.61 4.091 3.516 5.969 1.703 1.678 3.772 2.965 5.634 3.073l.088.005h.056c.064-.003.04-.003.063-.004h.025a1.11 1.11 0 00.406-.129.576.576 0 00.092-.065l.015-.013 1.975-1.605a.311.311 0 00.086-.104","fill":"#005149"}})])
          )
        }
      }
    